import React from "react";
import "./DownloadTab.css";
import "./DownloadButton.css";
import { Row, Col } from "react-bootstrap";
import Amplify, { API } from "aws-amplify"; //graphqlOperation
import aws_exports from "../aws-exports";
import  DownloadPdf from "./DownloadPdf.js";
Amplify.configure(aws_exports, {});

/*
    A container that is used to download the relevant files. Renderd inside of InformationTab
*/



export default class DownloadTab extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      index: 0,
      mseS3Path: "",
      pdfS3Path: "",
      blcS3Path: "",
      cntS3Path: ""
    };
  }

  componentDidUpdate() {
    /*     if(prevProps.index !== this.props.index){
      this.setState({
        index: this.props.index
      });
    } */
  }






  downloadMSE = () =>{


    return  DownloadPdf (this.props.mseS3Path)

  }

  downloadBLC = () =>{

    return  DownloadPdf (this.props.blcFilePath)
    
  }


  downloadPDF = () =>{

    return  DownloadPdf (this.props.pdfFilePath)
    
  }


  fetchCounterInfo = (S3Path, fileurl) => {
   
    let apiName = "vakicloudRdsAPI";
    let path = "/getFileBlob";
    let myInit = {
      // OPTIONAL
      headers: {
        "Content-Type": "binary/octet-stream"
      }, // OPTIONAL
      response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {
        // OPTIONAL
        S3Path: S3Path
      }
    };
    API.get(apiName, path, myInit).then(response => {
      if (response.failed === true) {
        alert("No File found");
      } else {
        var a = document.createElement("a");
        a.href = fileurl;
        a.download = true;
        a.click();
      }
    });
  };



  render() {
    let { pdfFileURL, mseFileURL, blcFileURL } = this.props;

    let ThePdf = "";

    if (this.props.pdfFilePath != null)
      ThePdf =  
      <Row>
      <Col >
      <button className = "buttonStyle"   onClick={this.downloadPDF} ><i className="fa fa-download" aria-hidden="true"></i> Download PDF File</button>
      </Col>;
      </Row>;


    return (
      <div className="dl-buttons">
        <h5>Download Reports & Technical Files </h5>
        <Row>
          <Col >
          <button className = "buttonStyle"   onClick={this.downloadMSE} ><i className="fa fa-download" aria-hidden="true"></i> Download MSE File</button>
          </Col>
        </Row>
        {ThePdf}

        <Row>
          <Col>
          <button className = "buttonStyle"   onClick={this.downloadBLC} > <i className="fa fa-download" aria-hidden="true"></i> Download BLC
          File</button>

          </Col>
        </Row>
      </div>
    );
  }
}
